<a
    class="c-pc-container"
    [ngClass]="{ condensed: condensed }"
    [href]="href"
    (click)="cardClicked($event)"
    [target]="openInNewTab ? '_blank' : null"
>
    <div class="h-hdc-image">
        <ng-container *ngIf="dealEntry.bannerImages?.length > 0; else noImages">
            <img
                class="h-hdc-image swiper-slide deals-slider"
                src="assets/img/deal_background.png"
                async
                *ngFor="let image of dealEntry.bannerImages"
                [lazyLoad]="image"
            />
        </ng-container>
        <ng-template #noImages>
            <img
                class="h-hdc-image"
                src="assets/img/deal_background.png"
                async
                [lazyLoad]="dealEntry.imageUrl"
            />
        </ng-template>
        <ng-container *ngIf="dealEntry.allInclusiveName">
            <div class="all-inclusive-overlay">
                {{ dealEntry.allInclusiveName }}
            </div>
        </ng-container>
        <div
            class="h-hdc-ribbon"
            *ngIf="!noBanners && dealEntry.ribbon?.ribbonName !== ''"
            [ngStyle]="{ 'background-color': dealEntry.ribbon.colorCode }"
        >
            <div class="h-hdc-ribbon-text">
                {{ dealEntry.ribbon.ribbonName }}
            </div>
        </div>
    </div>
    <md-date-badge
        [startDate]="dealEntry.startDate"
        [endDate]="dealEntry.endDate"
    />
    <div class="c-pc-text-container">
        <div class="c-pc-rating-like-container">
            <div class="c-pc-ratings">
                <div
                    class="c-pc-rating-value"
                    *ngIf="dealEntry.nrOfReviews > 0"
                >
                    {{ dealEntry.average | number : "1.1-1" }}
                </div>
                <div
                    class="c-pc-rating-value is-new"
                    *ngIf="dealEntry.nrOfReviews === 0"
                >
                    {{ "New" | translate }}
                </div>
                <div
                    class="c-pc-rating-label"
                    *ngIf="dealEntry.nrOfReviews > 0"
                >
                    {{ getRatingLabel(dealEntry.average) }}
                </div>
                <div
                    class="c-pc-rating-count"
                    *ngIf="dealEntry.nrOfReviews > 0"
                >
                    ({{ dealEntry.nrOfReviews }} {{ "Ratings" | translate }})
                </div>
            </div>
            <div class="c-pc-like-container">
                <div *ngIf="dealEntry.starCount > 0">
                    <span
                        class="h-hdc-rating"
                        *ngFor="let i of [].constructor(dealEntry.starCount)"
                    >
                        ★
                    </span>
                </div>
            </div>
        </div>
        <div class="h-hdc-title">
            <h4 class="h-hdc-title-text">{{ dealEntry.name }}</h4>
        </div>
        <div class="c-pc-fixed-details">
            <div class="c-pc-fixed-details-top">
                <div class="c-pc-details-left">
                    <div class="c-pc-details-left-location">
                        <img
                            [src]="'assets/icons/location.png'"
                            style="width: 11px; margin-right: 6px"
                        />
                        <div>{{ dealEntry.townName }}</div>
                    </div>
                    <div
                        *ngIf="!showSubtitleInsteadOfPills"
                        class="c-pc-details-left-facilities"
                    >
                        <div
                            class="c-pc-facility"
                            *ngFor="let facilityName of getFirstRowFacilities()"
                        >
                            {{ facilityName }}
                        </div>
                    </div>
                    <div
                        *ngIf="showSubtitleInsteadOfPills"
                        class="c-pc-details-left-facilities description"
                    >
                        {{ dealEntry.shortDescription }}
                    </div>
                </div>
                <div class="c-pc-details-right">
                    <span>{{ "as from" | translate }}</span>
                    <span class="h-hdc-specialPrice">
                        {{
                            dealEntry.specialPrice
                                | currency
                                    : currencySymbol
                                    : "symbol"
                                    : "1.0-2"
                                    : locale
                        }}
                    </span>
                    <span>{{
                        dealEntry.categoryId === 3 ||
                        dealEntry.categoryId === 21
                            ? ("per night" | translate)
                            : ("per unit" | translate)
                    }}</span>
                </div>
            </div>

            <div
                *ngIf="!showSubtitleInsteadOfPills"
                class="c-pc-fixed-details-bottom c-pc-details-left-facilities"
            >
                <div
                    class="c-pc-facility"
                    *ngFor="let facilityName of getSecondRowFacilities()"
                >
                    {{ facilityName }}
                </div>
            </div>
        </div>
        <div></div>
    </div>
</a>
